let _appPrices = [];
const observableAppPrices = new Rx.BehaviorSubject(_appPrices);

/**
 * @ngdoc service
 * @name repositories.AppPricesRepository
 *
 * @description
 * AppPricesRepository.
 */
const AppPricesRepository = {

    add(data) {

        data.forEach((item) => {

            const indexOfProduct = this.getIndex(item.id);

            if (indexOfProduct === -1) {

                _appPrices.push(item);
                observableAppPrices.onNext(_appPrices);

            }

        });

    },

    update(data) {

        data.forEach((item) => {

            const indexOfProduct = this.getIndex(item.id);

            if (indexOfProduct >= 0) {

                _appPrices[indexOfProduct] = item;
                observableAppPrices.onNext(_appPrices);

            }

        });

    },

    replace(data) {

        _appPrices = data;
        observableAppPrices.onNext(_appPrices);

    },

    getAll() {

        return _appPrices;

    },

    getIndex(dataId, runtime, devices) {

        return _appPrices.findIndex(_appPrice => String(_appPrice.id) === String(`${dataId}_${runtime}_${devices}`));

    },

    getSinglePrice(dataId, runtime, devices) {

        return _appPrices.find(_appPrice => String(_appPrice.id) === String(`${dataId}_${runtime}_${devices}`));

    },

    getObservable() {

        return observableAppPrices;

    },

};

export default AppPricesRepository;



// WEBPACK FOOTER //
// ./scripts/common/repositories/-RFC.appPricesRepository.js